<!-- 联系我们 -->
<template>
	<div>
		<!-- logo区域 -->
		<logo-head></logo-head>
		<!-- 导航菜单 -->
		<nav-head></nav-head>
		<div class="detail">
			<!-- 面包屑 -->
			<div class="breadCrumb">
				<span>当前位置：</span>
				<div class="pl-1 pt-1">
					<el-breadcrumb separator="/">
						<el-breadcrumb-item :to="{ path: '/' }">易知网</el-breadcrumb-item>
						<el-breadcrumb-item><a :href="mbxLink">{{mbx}}</a></el-breadcrumb-item>
						<el-breadcrumb-item>详情</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
			</div>
			<div class="detailContent">
				<!-- 标题 -->
				<div class="title">
					<h2>{{newsDetail.name}}</h2>
				</div>
				<!-- 作者，发布时间 -->
				<div class="authorDate">
					<span class="pr-5">作者：{{newsDetail.author}}</span>
					<span class="pr-5">发布时间：{{newsDetail.createAt}}</span>
					<span>来源：{{newsDetail.source}}</span>
				</div>
				<!-- 新闻内容 -->
				<div class="news">
					<div v-html="newsDetail.content"></div>
				</div>
			</div>
		</div>
		<!-- footer -->
		<Footer></Footer>
	</div>
</template>

<script>
	import logoHead from '@/components/logoHead/logoHead.vue'
	import navHead from '@/components/navHead/navHead.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			logoHead,
			navHead,
			Footer
		},
		data() {
			return {
				newsDetail:[],
				newsId:0,
				mbx:'',
				mbxLink:'',
				newsType:''
			}
		},
		mounted() {
			this.newsId = this.$route.query.id
			this.mbx = this.$route.query.mbx
			this.mbxLink = this.$route.query.mbxLink
			this.newsType = this.$route.query.newsType
			this.getNewsDetail()
		},
		methods: {
			getNewsDetail() {
				let vm = this
				let linkUrl = ''
				if(this.newsType == 'recruit'){
					linkUrl = `/api/recruit/findById/${this.newsId}`
				}else if(this.newsType == 'success'){
					linkUrl = `/api/success/case/detailFindById/${this.newsId}`
				}else if(this.newsType == 'social'){
					linkUrl = `/api/society/findById/${this.newsId}`
				}
				else{
					linkUrl = `/api/industry/new/detailFindById/${this.newsId}`
				}
				vm.axios.get(linkUrl).then(res => {
					vm.newsDetail = res.data.data
				})
			}
		},
	}
</script>

<style scoped>
	.detail{
		width: 100%;
		min-height: 500px;
		background-color: #f8f8f8;
		overflow: hidden;
	}
	/* 面包屑 */
	.breadCrumb{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		padding-top:20px;
		padding-bottom: 20px;
	}
	/* 内容详情 */
	.detailContent{
		width: 1200px;
		min-height:800px;
		background-color: #fff;
		margin: 0 auto;
		margin-bottom:20px;
	}
	/* 标题 */
	.detailContent .title{
		width:1140px;
		min-height: 100px;
		padding:30px;
		text-align: center;
		margin: 0 auto;
		border-bottom: 1px solid #eee;
	}
	/* 作者、发布时间 */
	.detailContent .authorDate{
		text-align: center;
		padding-top: 20px;
		color:#999;
	}
	/* 内容详情 */
	.detailContent .news{
		width: 1140px;
		margin: 0 auto;
		padding-top: 20px;
	}
</style>

